export default {"src":"/_next/static/media/adobe.9af71cb9.svg","height":80,"width":91,"blurWidth":0,"blurHeight":0};